module.exports = "<div class=card> <div class=head> <h1>{{ translate('cp.login') }}</h1> </div> <hr> <div v-if=!loggedIn class=\"loading loading-basic\"> <span class=\"icon icon-circular-graph animation-spin\"></span> {{ translate('cp.logging_in') }} </div> <p v-if=loggedIn>{{ translate('cp.logged_in_taking_you_to_cp') }}</p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/statamic/resources/js/components/installer/steps/login.template.html
// module id = 414
// module chunks = 0